
//对应后台管理维护系统的图片管理内的位置id
export const ImageTypeEnum = Object.freeze({
    HOME_BANNER: {
        value: '4',
        label: '用户端首页顶部banner图'
    },
    SALES_SEARCH: {
        value: '30',
        label: '用户端售后系统真伪查询背景图'
    },
    SALES_HOME_BANNER: {
        value: '81',
        label: '用户端售后系统首页banner图'
    },
    SALES_HOME_LIST: {
        value: '80',
        label: '用户端售后系统首页功能图标'
    },
    SHOP_HOME_LIST: {
        value: '36',
        label: '用户端产品详情内的旗舰店logo'
    },
    TABLE_HOME_LIST: {
        value: '75',
        label: '用户端璟点台球桌首页头部banner'
    },
    TABLE_HOME_DETAIL_LIST: {
        value: '76',
        label: '用户端璟点台球桌首页产品系列轮播图'
    },
    TABLE_CASE_LIST: {
        value: '77',
        label: '用户端璟点台球桌球馆案例'
    },
    TABLE_ARTICLE_LIST: {
        value: '78',
        label: '用户端璟点台球桌文章详情页头部banner'
    },
    TABLE_PRODUCT_DETAIL_LIST: {
        value: '52',
        label: '璟点台球桌分类节点id'
    },

    MAJOR_EVENT_LIST: {
        value: '82',
        label: '公司大事件顶部banner图'
    },
    EVENT_BANNER_LIST: {
        value: '83',
        label: '首页赛事顶部banner图'
    },
    PLAYER_HOME_BANNER: {
        value: '25',
        label: '签约球员列表页面banner'
    },
    PLAYER_DETAIL_BANNER: {
        value: '42',
        label: '球员详情banner'
    },
    CHECK_30_BANNER: {
        value: '30',
        label: '服务与支持-真伪查询页面banner图'
    },
    CHECK_84_CODE: {
        value: '84',
        label: '会员系统登录二维码'
    },
    CHECK_33_BANNER: {
        value: '33',
        label: '售后流程页面banner'
    },
    CHECK_34_BANNER: {
        value: '34',
        label: '服务与支持-常见问题页面banner'
    },
    CHECK_35_BANNER: {
        value: '35',
        label: '服务与支持-使用维护页面Banner'
    },
    CHECK_39_BANNER: {
        value: '39',
        label: '使用维护页面下方的图片'
    },
})